import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx';
import useDetectPrint from "use-detect-print";

const useStyles = makeStyles({
    root: {
    },
    header: {

    },
    table: {
        minWidth: '100%',
    },
    th: {
        paddingLeft: 0,
        width: '15%'
    },
    td: {
        paddingLeft: 0,
        width: '25%'
    },
    tm: {
        paddingLeft: 0,
        width: '50%'
    },
    detail: {
        marginTop: 10
    },
    btn: {
        marginLeft: 0,
        marginTop: 10,
    },
    contactIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 0,
        borderBottom: '1px dashed #ccc',
        paddingBottom: 5
    },
    last: {
        borderBottom: 0
    }
});

export default function OptionsTable(props) {
    const classes = useStyles();

    const allItems = props.items;
    const isPreview = props.isPreview;

    const isMobile = props.isMobile;

    let maxItems = isPreview ? (isMobile ? 10 : 10) : allItems.length;

    const isPrinting = useDetectPrint();

    if (isPrinting) {
        maxItems = allItems.length;
    }


    const hasExpand = allItems.length > maxItems;

    const items = allItems.slice(0, maxItems);

    const isSingleLine = items && items[0];

    const parts = isMobile ? [
        items.slice(0)
    ] : [
        items.slice(0, items.length/2),
        items.slice(items.length/2)
    ] ;

    return (
        <div className={classes.root}>
            {isSingleLine ?
                <Table className={classes.table} size="small" aria-label="details">
                    <TableBody>
                        {parts[0].map((detail, index) => (
                            <>
                                <TableRow key={detail.name}>
                                    <TableCell align="left" className={classes.tm}>⚡ {detail.value}</TableCell>
                                    {parts[1] && parts[1][index] ?
                                        <>
                                            <TableCell align="left"
                                                       className={classes.tm}>⚡ {parts[1][index].value}</TableCell>
                                        </> : ''}
                                </TableRow>
                            </>
                        ))}
                        {hasExpand ? <TableRow key="...">
                            <TableCell align="left" className={clsx(classes.tm, classes.last)}>...</TableCell>
                            {parts[1] ?
                                <TableCell align="left" className={clsx(classes.tm, classes.last)}>...</TableCell> : ''}
                        </TableRow> : ''}
                    </TableBody>
                </Table>
                :
                <Table className={classes.table} size="small" aria-label="details">
                    <TableBody>
                        {parts[0].map((detail, index) => (
                            <>
                                <TableRow key={detail.name}>
                                    <TableCell component="th" scope="row" className={classes.th}>
                                        <b>{detail.name}</b>
                                    </TableCell>
                                    <TableCell align="left" className={classes.td}>{detail.value}</TableCell>
                                    {parts[1] && parts[1][index] ?
                                        <>
                                            <TableCell component="th" scope="row" className={classes.th}>
                                                <b>{parts[1][index].name}</b>
                                            </TableCell>
                                            <TableCell align="left"
                                                       className={classes.td}>{parts[1][index].value}</TableCell>
                                        </> : ''}
                                </TableRow>
                            </>
                        ))}
                    </TableBody>
                </Table>
            }
        </div>
    );
}